module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Orage_01.f0aed8ad.png";